/**
 * Adaptive search debounce: results latency scales with the only real cost
 * driver — dataset size. Small libraries get a near-instant feel; large ones
 * get a wait long enough that the (heavier) filter work fires during natural
 * typing pauses instead of between fast keystrokes on slow hardware.
 *
 * Typing echo is never debounced (inputs write to state immediately); this
 * only gates when the grid engine recomputes results.
 */
export class SearchDebounce {
  /** Above this item count, filter compute is heavy enough to defer. */
  static readonly LARGE_DATASET_THRESHOLD = 5000;
  /** Imperceptible (<100ms end-to-end) but still coalesces paste/key bursts. */
  static readonly SMALL_DATASET_MS = 50;
  /** Fires on typing pauses; worst measured compute ~35ms on a 33k library. */
  static readonly LARGE_DATASET_MS = 150;

  static forItemCount(itemCount: number): number {
    return itemCount > SearchDebounce.LARGE_DATASET_THRESHOLD
      ? SearchDebounce.LARGE_DATASET_MS
      : SearchDebounce.SMALL_DATASET_MS;
  }
}
